import { render, staticRenderFns } from "./BasePrice.vue?vue&type=template&id=27317bbe&functional=true&"
import script from "./BasePrice.vue?vue&type=script&lang=ts&"
export * from "./BasePrice.vue?vue&type=script&lang=ts&"
import style0 from "./BasePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports